



































































































































import { computed, defineComponent,	PropType } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import HelpTooltip from '@front-app/components/dropdowns/HelpTooltip.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { GroupAccessMode, GroupAccessSettings } from '@front-app/services/GroupsApi/GroupAccessSettingsModel';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { Size, Spacing } from '@front-app/components/constants';
import { syncedRef } from '@front-app/util/reactivity';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useGroupAccessStore } from '@front-app/store/piniaModules/groupAccess';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		HelpTooltip,
		HelpTooltipBlock,
		SimpleCard,
		SuccessCard,
		TrCheckbox,
		TrForm,
	},
	props: {
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
	},
	setup(props) {
		const accessSettings = computed(() => {
			if (!props.group.accessSettings) {
				throw Error('Access settings are missing.');
			}
			return props.group.accessSettings;
		});

		const termsOfUse = syncedRef(() => accessSettings.value.termsOfUse).ref;
		const professionalsOnly = syncedRef(() => accessSettings.value.professionalsOnly).ref;
		const enableAccessCodes = syncedRef(() => accessSettings.value.enableAccessCodes).ref;
		const sharePersonalInformation = syncedRef(() => accessSettings.value.sharePersonalInformation).ref;
		const joinOnFirstAccess = syncedRef(() => accessSettings.value.joinOnFirstAccess).ref;

		// Toggle mutually-exclusive settings
		const toggleTermsOfUse = () => {
			termsOfUse.value = !termsOfUse.value;
			if (joinOnFirstAccess.value) {
				joinOnFirstAccess.value = !joinOnFirstAccess.value;
			}
			if (sharePersonalInformation.value) {
				sharePersonalInformation.value = !sharePersonalInformation.value;
			}
		};
		const toggleSharePersonalInformation = () => {
			sharePersonalInformation.value = !sharePersonalInformation.value;
			if (!termsOfUse.value) {
				termsOfUse.value = !termsOfUse.value;
			}
			if (joinOnFirstAccess.value) {
				joinOnFirstAccess.value = !joinOnFirstAccess.value;
			}
		};
		const toggleAccessCodes = () => {
			enableAccessCodes.value = !enableAccessCodes.value;
			if (joinOnFirstAccess.value) {
				joinOnFirstAccess.value = !joinOnFirstAccess.value;
			}
		};

		// Submission
		const {
			track,
			isError,
			isLoading,
			isSuccess,
		} = useAsyncStatus();
		const changeJoinRequirements = async () => {
			const payload: GroupAccessSettings = {
				accessMode: accessSettings.value.accessMode,
				professionalsOnly: professionalsOnly.value,
				restrictEmailDomain: accessSettings.value.restrictEmailDomain,
				emailDomain: accessSettings.value.emailDomain,
				termsOfUse: termsOfUse.value,
				enableAccessCodes: enableAccessCodes.value,
				sharePersonalInformation: sharePersonalInformation.value,
				paidEntry: accessSettings.value.paidEntry,
				joinOnFirstAccess: joinOnFirstAccess.value,
			};

			await track(useGroupAccessStore().changeGroupAccess(props.group.id, payload));
		};
		// END Submission

		return {
			isCsr: CurrentUserStore.isCsr,
			GroupAccessMode,
			accessSettings,
			termsOfUse,
			professionalsOnly,
			enableAccessCodes,
			sharePersonalInformation,
			toggleTermsOfUse,
			toggleSharePersonalInformation,
			toggleAccessCodes,
			// Submission
			changeJoinRequirements,
			isError,
			isLoading,
			isSuccess,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
